import ThemedSvgIcon from './ThemedSvgIcon';

const DiagramIcon = (props) => (
    <ThemedSvgIcon {...props}>
        {(fill) => (
            <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.5 5.75C20.5 7.12891 19.3789 8.25 18 8.25H3C1.62109 8.25 0.5 7.12891 0.5 5.75V3.25C0.5 1.87109 1.62109 0.75 3 0.75H18C19.3789 0.75 20.5 1.87109 20.5 3.25V5.75ZM18 15.75V13.25H3V15.75H18ZM18 18.25H3C1.62109 18.25 0.5 17.1289 0.5 15.75V13.25C0.5 11.8711 1.62109 10.75 3 10.75H18C19.3789 10.75 20.5 11.8711 20.5 13.25V15.75C20.5 17.1289 19.3789 18.25 18 18.25Z"
                    fill={fill}
                />
            </svg>
        )}
    </ThemedSvgIcon>
);

export default DiagramIcon;
